import React, { useEffect, useState } from "react";
import API from "../api";
import Layout from "../components/Layout";
import { toast } from "react-toastify";
import { FaTrash } from "react-icons/fa";

const SupplierReturns = () => {

    const [data, setData] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [products, setProducts] = useState([]);

    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    const [showModal, setShowModal] = useState(false);

    const [form, setForm] = useState({
        supplierId: "",
        supplierName: "",
        company: "",
        product: "",
        category: "",
        qty: "",
        reason: "",
        refundAmount: ""
    });

    // ================= FETCH =================

    const fetchData = async () => {

        try {

            const res = await API.get("/supplier-returns");

            setData(res.data);

        } catch {

            toast.error("Failed to load returns");
        }
    };

    const fetchSuppliers = async () => {

        try {

            const res = await API.get("/suppliers");

            setSuppliers(res.data);

        } catch {

            toast.error("Failed to load suppliers");
        }
    };

    const fetchProducts = async () => {

        try {

            const res = await API.get("/products");

            setProducts(res.data);

        } catch {

            toast.error("Failed to load products");
        }
    };

    useEffect(() => {

        fetchData();
        fetchSuppliers();
        fetchProducts();

    }, []);

    // ================= ADD RETURN =================

    const handleSubmit = async () => {

        try {

            if (
                !form.company ||
                !form.supplierName ||
                !form.product ||
                !form.qty
            ) {

                toast.error("Please fill required fields");

                return;
            }

            const payload = {
                supplierId: form.supplierId,
                supplierName: form.supplierName,
                company: form.company,
                product: form.product,
                category: form.category,
                qty: Number(form.qty),
                reason: form.reason,
                refundAmount: Number(form.refundAmount)
            };

            const res = await API.post(
                "/supplier-returns",
                payload
            );

            toast.success("Return Added");

            setData([res.data, ...data]);

            setShowModal(false);

            setForm({
                supplierId: "",
                supplierName: "",
                company: "",
                product: "",
                category: "",
                qty: "",
                reason: "",
                refundAmount: ""
            });

        } catch (err) {

            console.log(err);

            toast.error("Error adding return");
        }
    };

    // ================= DELETE =================

    const handleDelete = async (id) => {

        if (!window.confirm("Delete this item?"))
            return;

        try {

            await API.delete(`/supplier-returns/${id}`);

            toast.success("Deleted");

            setData(
                data.filter(item => item._id !== id)
            );

        } catch {

            toast.error("Delete failed");
        }
    };

    // ================= SEARCH =================

    const filteredData = data.filter((item) => {

        const supplier =
            item.supplierName?.toLowerCase() || "";

        const company =
            item.company?.toLowerCase() || "";

        const product =
            item.product?.name?.toLowerCase() || "";

        const category =
            item.category?.toLowerCase() || "";

        const text =
            search.toLowerCase();

        return (

            supplier.includes(text) ||
            company.includes(text) ||
            product.includes(text) ||
            category.includes(text)

        );
    });

    // ================= PAGINATION =================

    const perPage = Number(limit);

    const start = (page - 1) * perPage;

    const currentData =
        filteredData.slice(start, start + perPage);

    const totalPages =
        Math.ceil(filteredData.length / perPage);

    return (

        <Layout>

            {/* ================= HEADER ================= */}

            <div className="header-row">

                <h2>Supplier Return Items</h2>

                <button
                    className="add-btn"
                    onClick={() => setShowModal(true)}
                >
                    + Add Return Item
                </button>

            </div>

            {/* ================= TABLE ================= */}

            <div className="table-section">

                <div className="table-controls">

                    {/* LIMIT */}

                    <div>

                        Show

                        <select
                            value={limit}
                            onChange={(e) =>
                                setLimit(e.target.value)
                            }
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>

                        entries

                    </div>

                    {/* SEARCH */}

                    <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) =>
                            setSearch(e.target.value)
                        }
                    />

                </div>

                {/* ================= TABLE ================= */}

                <div className="table-responsive">

                    <table className="supplier-returns-table">

                        <thead>

                            <tr>

                                <th>S/N</th>
                                <th>Supplier</th>
                                <th>Company</th>
                                <th>Product</th>
                                <th>Category</th>
                                <th>Qty</th>
                                <th>Reason</th>
                                <th>Refund</th>
                                <th>Date</th>
                                <th>Action</th>

                            </tr>

                        </thead>

                        <tbody>

                            {
                                currentData.length > 0 ? (

                                    currentData.map((d, i) => (

                                        <tr key={d._id}>

                                            <td>{i + 1}</td>

                                            <td>
                                                {d.supplierName}
                                            </td>

                                            <td>
                                                {d.company}
                                            </td>

                                            <td>
                                                {d.product?.name}
                                            </td>

                                            <td>
                                                {d.category}
                                            </td>

                                            <td>
                                                {d.qty}
                                            </td>

                                            <td>
                                                {d.reason}
                                            </td>

                                            <td>
                                                ₹{d.refundAmount}
                                            </td>

                                            <td>

                                                {
                                                    new Date(
                                                        d.createdAt
                                                    )
                                                        .toLocaleDateString(
                                                            "en-GB"
                                                        )
                                                        .replace(/\//g, "-")
                                                }

                                            </td>

                                            <td>

                                                <button
                                                    className="delete-btn"
                                                    onClick={() =>
                                                        handleDelete(d._id)
                                                    }
                                                >
                                                    <FaTrash />
                                                </button>

                                            </td>

                                        </tr>

                                    ))

                                ) : (

                                    <tr>

                                        <td colSpan="10">
                                            No Data Found
                                        </td>

                                    </tr>

                                )
                            }

                        </tbody>

                    </table>

                </div>

                <div className="pagination">

                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {Array.from(
                        { length: totalPages },
                        (_, i) => (

                            <button
                                key={i}
                                className={
                                    page === i + 1
                                        ? "active"
                                        : ""
                                }
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>

                        )
                    )}

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>

            </div>

            {/* ================= MODAL ================= */}

            {
                showModal && (

                    <div className="modal-overlay">

                        <div className="modal-box">

                            <h3>

                                Add Return Item

                                <span
                                    style={{
                                        float: "right",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        setShowModal(false)
                                    }
                                >
                                    ✖
                                </span>

                            </h3>

                            {/* ================= COMPANY ================= */}

                            <select
                                value={form.company}
                                onChange={(e) => {

                                    const selectedCompany =
                                        e.target.value;

                                    const selectedSupplier =
                                        suppliers.find(
                                            (s) =>
                                                s.company ===
                                                selectedCompany
                                        );

                                    setForm({
                                        ...form,

                                        company:
                                            selectedCompany,

                                        supplierId:
                                            selectedSupplier?._id || "",

                                        supplierName:
                                            selectedSupplier?.name || "",

                                        product: "",

                                        category: ""
                                    });
                                }}
                            >

                                <option value="">
                                    Select Company
                                </option>

                                {
                                    [...new Set(
                                        suppliers.map(
                                            (s) => s.company
                                        )
                                    )]
                                        .filter(Boolean)
                                        .map((company, i) => (

                                            <option
                                                key={i}
                                                value={company}
                                            >
                                                {company}
                                            </option>

                                        ))
                                }

                            </select>

                            {/* ================= SUPPLIER ================= */}

                            <input
                                type="text"
                                placeholder="Supplier Name"
                                value={form.supplierName}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        supplierName:
                                            e.target.value
                                    })
                                }
                            />

                            {/* ================= PRODUCT ================= */}

                            <select
                                value={form.product}
                                onChange={(e) => {

                                    const selectedProduct =
                                        products.find(
                                            (p) =>
                                                p._id ===
                                                e.target.value
                                        );

                                    setForm({
                                        ...form,

                                        product:
                                            e.target.value,

                                        category:
                                            selectedProduct?.category || ""
                                    });
                                }}
                            >

                                <option value="">
                                    Select Product
                                </option>

                                {
                                    products
                                        .filter((p) => {

                                            const supplierId =
                                                p.supplier?._id || p.supplier;

                                            return (
                                                supplierId?.toString() ===
                                                form.supplierId?.toString()
                                            );
                                        })
                                        .map((p) => (

                                            <option
                                                key={p._id}
                                                value={p._id}
                                            >
                                                {p.name}
                                            </option>

                                        ))
                                }

                            </select>

                            {/* ================= CATEGORY ================= */}

                            <select
                                value={form.category}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        category: e.target.value
                                    })
                                }
                            >

                                <option value="">
                                    Select Category
                                </option>

                                {
                                    [...new Set(

                                        products
                                            .filter((p) => {

                                                const supplierId =
                                                    p.supplier?._id || p.supplier;

                                                return (
                                                    supplierId?.toString() ===
                                                    form.supplierId?.toString()
                                                );
                                            })
                                            .map((p) => p.category)

                                    )]
                                        .filter(Boolean)
                                        .map((cat, i) => (

                                            <option
                                                key={i}
                                                value={cat}
                                            >
                                                {cat}
                                            </option>

                                        ))
                                }

                            </select>

                            {/* ================= QTY ================= */}

                            <input
                                type="number"
                                placeholder="Quantity"
                                value={form.qty}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        qty: e.target.value
                                    })
                                }
                            />

                            {/* ================= REASON ================= */}

                            <input
                                type="text"
                                placeholder="Reason"
                                value={form.reason}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        reason: e.target.value
                                    })
                                }
                            />

                            {/* ================= REFUND ================= */}

                            <input
                                type="number"
                                placeholder="Refund Amount"
                                value={form.refundAmount}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        refundAmount:
                                            e.target.value
                                    })
                                }
                            />

                            {/* ================= BUTTON ================= */}

                            <div className="modal-actions">

                                <button
                                    className="create-btn"
                                    onClick={handleSubmit}
                                >
                                    Save
                                </button>

                                <button
                                    className="cancel-btn"
                                    onClick={() =>
                                        setShowModal(false)
                                    }
                                >
                                    Cancel
                                </button>

                            </div>

                        </div>

                    </div>

                )
            }

        </Layout>

    );
};

export default SupplierReturns;
